<template>
  <Layout :footer-style="2" header-class="header-left-align" nav-alignment="right" :header-transparency="false" :show-top-header="true" buy-button-class="btn-default btn-small">

    <!-- Start Brand Area  -->
    <div class="rwt-brand-area rn-section-gap">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <SectionTitle
                subtitle="YAO XIE GONG MAO"
                text-align="center"
                title="合作加盟"
                data-aos="fade-up"
            />
          </div>
        </div>
        <div >

            <div class="col-lg-12 mt--40 ">
<!--              <Brand :brand-list="brandList4"/>-->
              <div class="row row--30">
                <div class="col-lg-6 order-2 oder-lg-1 mt_md--30 mt_sm--30">
                  <div class="thumbnail">
                    <img class="radius w-100"
                         src="../../assets/images/joinUs/join_us_01.jpg"
                         alt="Corporate"/>
                  </div>
                </div>
                <div class="col-lg-6 order-1 oder-lg-2">
                  <div class="thumbnail">
                    <img class="radius w-100"
                         src="../../assets/images/joinUs/join_us_02.jpg"
                         alt="Corporate"/>
                  </div>
                </div>
              </div>

            </div>

            <div class="mt--40" v-if="!showResult">
              <form :model="form" class="contact-form-1"  >

                <div class="row row--30">
                  <div class="form-group col-lg-6 col-md-6 col-sm-12" >
                    <div class="el-form-item">
                      <label class="el-form-item__label" >您的称呼：</label>
                    </div>
                    <div class="el-form-item__content">
                      <div class="el-input">
                        <input
                            maxlength="20"
                            style="width: 100%;"
                            type="text"
                            name="fullname"
                            v-model="form.fullname"
                            placeholder="请输入您的称呼"
                            required
                        />
                      </div>

                    </div>
                  </div>
                  <div class="form-group col-lg-6 col-md-6 col-sm-12">

                    <div class="el-form-item">
                      <label class="el-form-item__label" >联系方式：</label>
                    </div>
                    <div class="el-form-item__content">
                      <div class="el-input">
                        <input
                            maxlength="13"
                            type="text"
                            name="phone"
                            v-model="form.phone"
                            placeholder="请输入您的联系方式"
                            required
                        />
                      </div>

                    </div>
                  </div>

                  <div class="form-group col-lg-12 col-md-12 col-sm-12">

                    <div class="el-form-item">
                      <label class="el-form-item__label" >意向合作地区：</label>
                    </div>
                    <div class="el-form-item__content">
                      <div class="el-input">
                        <input
                            maxlength="50"
                            type="text"
                            name="area"
                            v-model="form.area"
                            placeholder="请填写意向合作地区"
                            required
                        />
                      </div>

                    </div>
                  </div>


                  <div class="form-group col-lg-12 col-md-12 col-sm-12">

                    <div class="el-form-item">
                      <label class="el-form-item__label" >留言：</label>
                    </div>
                    <div class="el-form-item__content">
                      <div class="el-input">
                        <textarea
                            maxlength="300"
                            v-model="form.message"
                            name="message"
                        >  </textarea>
                      </div>

                    </div>

                  </div>


                </div>
              </form>
              <div  v-if="!isDisabled">
                <div class="col-lg-12 col-md-12 col-sm-12">


                  <div class="el-form-item__content">
                    <div class="el-input" style="text-align: center;">
                      <button  class="btn-default btn-large" @click="submitForm">立即咨询</button>
                    </div>

                  </div>
                </div>
              </div>
            </div>


          </div>




        <div class="form-group" style="width: 100%" v-if="showResult" >

            <CallToAction
                :style-type="8"
                title="感谢您的咨询!"
                subtitle=""
                btn-text="返回首页"
            />


        </div>


      </div>
    </div>
    <!-- End Brand Area  -->
  </Layout>
</template>
<script>
  import Layout from "../../components/common/Layout";
  import SectionTitle from "../../components/elements/sectionTitle/SectionTitle";
  import CallToAction from "../../components/elements/callToAction/CallToAction";
  export default {
    name: 'JoinUs',
    components: {Layout,CallToAction,SectionTitle},
    data() {
      return {
        form:{
          fullname: undefined,
          phone: undefined,
          area: undefined,
          message:undefined,
          isDel: 0,
          type: '1'
        },
        showResult: false,
        isDisabled: false,

      }
    },
    methods: {
      submitForm() {
        this.isDisabled = true;
        this.postRequest('/system/web/join',this.form).then(resp=>{
            if(resp.data.code === 200){
              this.showResult = true;
            }
        });

      }
    }
  }
</script>

<style scoped>

</style>